import { useTheme } from 'foundations-theming/utils';
import { useCallback } from 'react';
import styled from 'foundations-theming-specialty/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import IconWithClickAnimation from './IconWithClickAnimation';
import { NOT_USING_TRACKER } from '../../../hooks/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyIconButton = styled(UICopyButton).withConfig({
  displayName: "CopyMessageActionButton__CopyIconButton",
  componentId: "z280ux-0"
})(["&&&{border:none;background:inherit;margin-top:", ";margin-left:", ";padding-left:", ";padding-right:", ";text-align:center;text-overflow:clip;&:hover{background:", ";}}&&{font-size:", ";width:", ";}"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.color['fill-field-hover'], ({
  theme
}) => theme.typography['body-200'].fontSize, ({
  theme
}) => theme.space['800']);
const CopyMessageActionButton = ({
  message,
  usageTracker
}) => {
  const trellisTheme = useTheme();
  const onCopyButtonClick = useCallback(() => {
    if (usageTracker && usageTracker !== NOT_USING_TRACKER) {
      usageTracker.track('copyMessageInteraction', {
        action: 'prompt_copied'
      });
    }
  }, [usageTracker]);
  return /*#__PURE__*/_jsx(CopyIconButton, {
    "data-test-id": "copy-button",
    hint: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.inlineFeedback.copyButton.hint"
    }),
    onClick: onCopyButtonClick,
    tooltipPlacement: "right",
    use: "tertiary-extra-light",
    size: "sm",
    value: message,
    children: /*#__PURE__*/_jsx(IconWithClickAnimation, {
      color: trellisTheme.color['icon-core-default'],
      name: "clipboard",
      size: "xxs"
    })
  });
};
export default CopyMessageActionButton;